const kia = {
  FORMS: [],
  CSS: {
    id: '3',
    name: 'kia',
    avatar: {
      name: 'Kian',
      header: 'https://chatbotqa.gatblac.com/static/avatar/kia/logo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/kia/avatar-kia.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/kia/chat-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/kia/chat-close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#bb162b',
        borderColor: '#bb162b'
      }
    }
  }
}

export default kia
